import { useCallback, useEffect, useState } from 'react';

export enum View {
  Mobile = 'mobile',
  Desktop = 'desktop',
  Tablet = 'tablet',
}

export enum Orientation {
  Portrait = 'portrait',
  Landscape = 'landscape',
}

export enum Device {
  Android,
  iPhone,
  iPad,
  iPod,
  WindowsPhone,
  Mac,
  WindowsPC,
  Linux,
  BlackBerry,
  Unknown,
}

const useIsMobile = () => {
  const detectView = (): View => {
    if (!window.matchMedia) return View.Mobile;
    if (window.matchMedia('(min-width: 1025px)').matches) {
      return View.Desktop;
    }
    if (
      window.matchMedia('(min-width: 481px) and (max-width: 1024px)').matches
    ) {
      return View.Tablet;
    }
    return View.Mobile;
  };

  const detectOrientation = (): Orientation => {
    if (!window.matchMedia) {
      return Orientation.Portrait;
    }
    if (window.matchMedia('(orientation: portrait)').matches) {
      return Orientation.Portrait;
    }
    return Orientation.Landscape;
  };

  const detectDeviceType = (): Device => {
    const userAgent = navigator.userAgent;

    switch (true) {
      case /Android/i.test(userAgent):
        return Device.Android;
      case /iPhone/i.test(userAgent):
        return Device.iPhone;
      case /iPad/i.test(userAgent):
        return Device.iPad;
      case /iPod/i.test(userAgent):
        return Device.iPod;
      case /Windows Phone|iemobile|WPDesktop/i.test(userAgent):
        return Device.WindowsPhone;
      case /Macintosh|MacIntel|MacPPC|Mac68K/i.test(userAgent):
        return Device.Mac;
      case /Windows|Win16|Win32|Win64/i.test(userAgent):
        return Device.WindowsPC;
      case /Linux/i.test(userAgent):
        return Device.Linux;
      case /BB/i.test(userAgent):
        return Device.BlackBerry;
      default:
        return Device.Unknown;
    }
  };

  const [view, setView] = useState<View>(detectView());
  const [orientation, setOrientation] =
    useState<Orientation>(detectOrientation());
  const [device, setDevice] = useState<Device>(detectDeviceType());

  const onResize = useCallback(() => {
    setView(detectView());
    setOrientation(detectOrientation());
    setDevice(detectDeviceType());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return { view, orientation, device };
};

export default useIsMobile;
